import React from "react";
import Layout from "../layout/Layout";
import Footer from "../components/Footer";
import GuideCard from "../containers/GuideCard";

const Guide = () => {
  return (
    <Layout>
      <div className="flex flex-col flex-1 h-full overflow-hidden bg-background">
        <section className="flex-1 flex flex-col min-h-0 overflow-y-auto">
          <div className="flex flex-col min-h-full">
            <div className="flex-1 flex flex-col">
              <GuideCard />
            </div>
            <Footer className="mt-10" />
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Guide;
